import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Table, Statistic, Row, Col, Button } from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
const { Text } = Typography;

const columnsCSV = [
	{ key: "truck", label: "Truck" },
	{ key: "driver", label: "Driver" },
	{ key: "ticket", label: "Ticket" },
	{ key: "material", label: "Material" },
	{ key: "quantity", label: "Quantity" },
];

const LogisticsReportTripsPerDriver = () => {
	const [loading, setLoading] = useState(true);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [list, setList] = useState([]);
	const [listCSV, setListCSV] = useState([]);
	const refDownload = useRef();

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Trips #",
			dataIndex: "count",
			key: "count",
			render: (value) => {
				return (
					<Statistic
						title=""
						value={value}
						precision={0}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
	];

	const expandedRowRender = (row) => {
		const columns = [
			{
				title: "Truck",
				dataIndex: "truck",
				key: "truck",
				render: (value) => {
					return <Text>{value.number}</Text>;
				},
			},
			{
				title: "Driver",
				dataIndex: "driver",
				key: "driver",
				render: (value) => {
					return <Text>{value.name}</Text>;
				},
			},
			{
				title: "Ticket",
				dataIndex: "ticket",
				key: "ticket",
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
			{
				title: "Material",
				dataIndex: "material",
				key: "material",
				render: (value) => {
					return <Text>{value}</Text>;
				},
			},
			{
				title: "Quantity",
				dataIndex: "quantity",
				key: "quantity",
				render: (value) => {
					return (
						<Statistic
							title=""
							value={value}
							precision={2}
							valueStyle={{ fontSize: 14 }}
						/>
					);
				},
			},
		];

		let trips = row.trips.map((item, index) => {
			item.key = index;
			return item;
		});

		return <Table columns={columns} dataSource={trips} pagination={false} />;
	};

	useEffect(() => {
		getLogisticsList();
	}, [startDate, endDate]);

	const getLogisticsList = async () => {
		setLoading(true);
		setListCSV([]);

		const start = `${startDate.year()}-${
			startDate.month() + 1
		}-${startDate.date()}`;
		const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

		const url =
			api +
			`/logisticstrip/list/tripsperdriver?startDate=${start}&endDate=${end}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			let listRows = [];
			data.map((item, index) => {
				list.push({
					key: index,
					id: item._id,
					driver: item.driver_details.name,
					count: item.count,
					trips: item.trips,
				});
				item.trips.map((trip) => {
					listRows.push({
						driver: trip.driver.name,
						truck: trip.truck.number,
						quantity: trip.quantity,
						material: trip.material,
						ticket: trip.ticket,
					});
				});
			});
			list = list.sort((a, b) => a.driver - b.driver);
			setList(list);
			setListCSV(listRows);
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={list}
					expandable={{
						expandedRowRender,
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [10, 20, 50, 100],
						defaultPageSize: 10,
						showSizeChanger: true,
					}}
					scroll={{
						x: true,
					}}
					style={{
						minWidth: "100%",
					}}
				/>
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderDates = () => {
		return (
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				dateFormat={"MM/DD/YYYY"}
				onRangeChange={onRangeChange}
			/>
		);
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={listCSV}
					headers={columnsCSV}
					filename={"57concrete-logistics-trips-per-driver.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading}
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<Layout
			title="Total Trips Per Driver"
			description="Logistics Report"
			type="medium"
		>
			<Flex vertical gap={"large"}>
				<RenderDates />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
		</Layout>
	);
};

export default LogisticsReportTripsPerDriver;
